// src/lib/useDpcCoef.ts
// [2026-07-17] DPC 医療機関別係数 (月次 effective-dated) を /api/query/dpc_coef から取得。
// 源 = dim_dpc_coef (= 電カル masijinyusysf ssicd='03036000' nsysno='A00000'、
// build_dashboard_db.R が emr_cache.duckdb から月次取り込み)。
// DpcTensuPanel が「表示期間の終了月に有効な係数」を default に使う (請求月適用)。
import { useQuery } from "@tanstack/react-query";
import type { DpcCoefResponse } from "@shared/api";
import { GP_MODE_HEADER } from "./gpMode";

export function useDpcCoef() {
  return useQuery({
    queryKey: ["dpc_coef"],
    queryFn: async () => {
      const r = await fetch("/api/query/dpc_coef", { credentials: "include", headers: { ...GP_MODE_HEADER } });
      if (!r.ok) throw new Error(`dpc_coef ${r.status}`);
      return r.json() as Promise<DpcCoefResponse>;
    },
    staleTime: Infinity,
  });
}
